"use server";

import { revalidateTag, updateTag } from "@rangojs/router";

const LAB_TAG = "lab";

/**
 * Read-your-own-writes purge. `updateTag` is awaited, so by the time this action
 * returns and the current route re-renders, the "lab"-tagged segment is already
 * invalidated and the page renders a fresh stamp.
 */
export async function invalidateUpdate(formData: FormData) {
  const tag = (formData.get("tag") as string) || LAB_TAG;
  await updateTag(tag);
}

/**
 * Fire-and-forget purge. `revalidateTag` defers the invalidation to a background
 * waitUntil and is not awaited, so this action's own re-render may still show the
 * old stamp — reload after a moment to see it refresh.
 */
export async function invalidateRevalidate(formData: FormData) {
  const tag = (formData.get("tag") as string) || LAB_TAG;
  revalidateTag(tag);
}
